import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ContractTemplatesApiAdapter } from '../adapters/ContractTemplatesApiAdapter';

export const useContractTemplates = () => {
    const apiAdapter = useMemo(() => {
        const httpClient = createHttpClient(apiClientWH);
        return new ContractTemplatesApiAdapter(httpClient);
    }, []);

    const { data, isLoading: loading, error } = useQuery({
        queryKey: ['contract-templates'],
        queryFn: async () => {
            const response = await apiAdapter.getTemplates();
            return response;
        },
        staleTime: 5 * 60 * 1000, // 5 minutos
    });

    const templates = data ?? [];

    return {
        templates,
        loading,
        error,
    };
};

